import React from "react";
import {Pie, PieChart, ResponsiveContainer} from "recharts";
import {getColorByName} from "../../utils/ColorUtils";
import "./_skeleton.scss";
import SkeletonText from "./SkeletonText";

export default function SkeletonPieChartSolidWithLegend() {
    return (
        <div className="w-100 h-100 d-flex">
            <div className="w-50 h-100">
                <ResponsiveContainer
                    height="100%"
                    className="statistics-pie-chart">
                    <PieChart>
                        <Pie
                            data={[
                                {value: 1, fill: getColorByName("secondary")},
                            ]}
                            dataKey={"value"}
                            stroke={null}
                            startAngle={90}
                            endAngle={470}
                            isAnimationActive={false}
                            className="skeleton-svg"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div className="w-50 h-100 d-flex align-items-center">
                <ul className="w-100">
                    <li className="mb-2">
                        <SkeletonText />
                    </li>
                    <li className="mb-2">
                        <SkeletonText />
                    </li>
                    <li className="mb-2">
                        <SkeletonText />
                    </li>
                    <li>
                        <SkeletonText />
                    </li>
                </ul>
            </div>
        </div>
    );
}
